import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { installRequestLoopGuard } from '@/lib/requestLoopGuard'
import { controleerBuildIdentiteit, verhoogPogingen } from '@/lib/buildIdentiteit'
import { toonVerouderdeBuild } from '@/lib/herlaadverzoek'
import { grendelOmgeving } from '@/lib/omgevingsGrendelBoot'
import { initSentry } from '@/lib/sentry'

import './index.css'
import App from './App.tsx'
import { ThemeProvider } from './theme/ThemeProvider'
import { AppErrorBoundary } from './components/AppErrorBoundary'
import { AuthProvider } from './hooks/useAuth'

const rootEl = document.getElementById('root')!

/*
 * EERST DE OMGEVINGSGRENDEL. Klopt de combinatie app × origin × Supabase-project
 * niet, dan wordt er niets gemount: geen router, geen sessieherstel, geen
 * auth-request. Aanleiding: een verouderd Operator App-artefact draaide onder
 * portal.collectr.be tegen het DEV-project (01-09-2026).
 */
if (grendelOmgeving('operator', rootEl)) {
  initSentry()
  // Ná initSentry: de guard meldt via Sentry, dus die moet eerst staan.
  installRequestLoopGuard()

  createRoot(rootEl).render(
    <StrictMode>
      <AppErrorBoundary>
        <AuthProvider><ThemeProvider><App /></ThemeProvider></AuthProvider>
      </AppErrorBoundary>
    </StrictMode>,
  )

  /*
   * STILLE VEROUDERING — de ingebakken build-id tegen `build-meta.json`, dat
   * altijd onbewaard wordt opgehaald. Bij verschil eerst gecontroleerd herladen,
   * en helpt dat niet, dan stoppen: doorwerken met code die aantoonbaar niet
   * meer klopt is precies wat dit moet voorkomen. De teller in `sessionStorage`
   * begrenst het aantal herladingen, zodat er geen lus kan ontstaan.
   *
   * Bij het opstarten én bij terugkeer op het tabblad; een tab kan dagen open
   * staan zonder ooit de focus te verliezen.
   */
  const controleer = () => {
    void controleerBuildIdentiteit(window.sessionStorage).then(({ uitkomst, actie }) => {
      if (actie === 'herladen' && uitkomst.soort === 'verouderd') {
        verhoogPogingen(window.sessionStorage)
        window.location.reload()
        return
      }
      if (actie === 'blokkeren' && uitkomst.soort === 'verouderd') {
        toonVerouderdeBuild(document, {
          draaiend: uitkomst.draaiend,
          actueel: uitkomst.actueel,
        })
      }
    })
  }
  controleer()
  window.addEventListener('focus', controleer)
}
